import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function EGovernment() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>e-Government</h1>
          <p>
            For efficient, transparent, paperless office and good governance.
          </p>
        </div>
        <div className="details-body">
          <p>
            This is an electronic workplace for efficient, transparent,
            paperless office and good governance. It reduces process delays,
            helps to access and utilize information quickly and expedite work.
            It automates day-to-day functions at all levels of the
            administrative hierarchy. Our e-Government Suite combines Business
            Process Management and Document Management Solutions to deliver a
            unified platform for Government to Citizen (G2C), Government to
            Business (G2B) and Government to Government Agencies (G2G)
            processes.
          </p>
        </div>
        <div className="details-features">
          <p>
            The e-Government Suite will seat at the centre of all business
            automation applications. It has the following modules:
          </p>
          <ol>
            <li>
              <p>
                Electronic File System (E-File) & Correspondence Management.
              </p>
            </li>
            <li>
              <p>Legal/ Case Management (Processing Of Court Cases).</p>
            </li>
            <li>
              <p>Business Process Management/Workflow Automation.</p>
            </li>
            <li>
              <p>Electronic Document and Content Management System.</p>
            </li>
            <li>
              <p>Enterprise Resource Management.</p>
            </li>
            <li>
              <p>Visitors Management System.</p>
            </li>
            <li>
              <p>
                Central Electronic License and Permit System/Central Permit
                Portals.
              </p>
            </li>
            <li>
              <p>E-Collaboration Suite.</p>
            </li>
          </ol>
        </div>
        <div className="details-features">
          <p>
            <span>Key Features</span>
          </p>
          <ol>
            <li>
              <p>Online repository of legal cases for faster retrieval</p>
            </li>
            <li>
              <p>Registration and tracking of court cases</p>
            </li>
            <li>
              <p>Registration and tracking of legal advices</p>
            </li>
            <li>
              <p>Real time report on lab-wise pending case details</p>
            </li>
            <li>
              <p>
                Online collaborations on contract agreement preparations and
                management
              </p>
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EGovernment;
